import { TCoordinates } from '../types';

export const getRectCenterPointCoords = (leftTop: TCoordinates, rightBottom: TCoordinates): TCoordinates => {
  return {
    x: (leftTop.x + rightBottom.x) / 2,
    y: (leftTop.y + rightBottom.y) / 2,
  };
};
